import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const t = await api.get("/tenants/current");
      setTenant(t.data);
    } catch (e) { /* tenant not seeded yet */ }
    if (localStorage.getItem("europedu_token")) {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data.user);
        setProfile(data.profile);
      } catch (e) {
        localStorage.removeItem("europedu_token");
      }
    }
    setLoading(false);
  };

  useEffect(() => { refresh(); }, []);

  const login = async (payload) => {
    const { data } = await api.post("/auth/login", payload);
    if (data.mfa_required || data.mfa_setup_required) return data;
    localStorage.setItem("europedu_token", data.token);
    setUser(data.user);
    await refresh();
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("europedu_token", data.token);
    setUser(data.user);
    await refresh();
    return data;
  };

  const logout = () => {
    localStorage.removeItem("europedu_token");
    setUser(null);
    setProfile(null);
  };

  const hasRole = (...roles) =>
    !!user && (user.roles.includes("super_admin") || roles.some((r) => user.roles.includes(r)));

  return (
    <AuthContext.Provider value={{ user, profile, tenant, loading, login, register, logout, hasRole, refresh, setTenant }}>
      {children}
    </AuthContext.Provider>
  );
};
